import { makeStyles } from "@material-ui/core";
import { h4Medium, h5Medium, h5Regular, h6Medium, h6Regular, h7Regular } from "../../../shared/typography";
import { pointer } from "../../../shared/mixins";

// Overrides the shared Checkbox component's label (global .h6-regular class)
// and checkmark box size for the "Default" indicator on this card.
const defaultCheckboxOverrides = {
  "& .container": {
    marginBottom: 0,
    color: "#15222F",
    opacity: 0.8,
    fontFamily: "Barlow",
    fontSize: 17,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  "& .checkmark": {
    width: 24,
    height: 24,
  },
};

export const useStyles = makeStyles(() => ({
  reg: {
    alignSelf: "start",
    "@media (max-width:940px)": {
      display: "none",
    },
  },
  res: {
    display: "none",
    "@media (max-width:940px)": {
      display: "block",
    },
  },
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    borderRadius: 16,
    padding: 40,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    maxWidth: 540,
    width: "100%",
    maxHeight: 300,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
  },
  issuerLogo: {
    width: 48,
    height: 48,
    "@media (max-width:940px)": {
      width: 32,
      height: 32,
    },
  },
  removeButton: {
    ...h6Medium,
    color: "#F50050",
    textAlign: "right",
    background: "none",
    border: "none",
    padding: 0,
    ...pointer,
    "&:disabled": {
      opacity: 0.5,
      cursor: "default",
    },
  },
  cardNumber: {
    fontFamily: "Barlow, Assistant",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 27,
    lineHeight: "normal",
    letterSpacing: "10px",
    color: "#15222F",
    opacity: 0.8,
    marginBottom: 32,
  },
  cardNumberMobile: {
    ...h5Regular,
    letterSpacing: "10px",
    opacity: 0.8,
    marginBottom: 32,
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 8,
  },
  cardHolderName: {
    ...h6Regular,
    opacity: 0.8,
    "@media (max-width:940px)": {
      ...h7Regular,
      opacity: 0.8,
    },
  },
  expiration: {
    ...h6Regular,
    opacity: 0.8,
    textAlign: "right",
    "@media (max-width:940px)": {
      ...h7Regular,
      opacity: 0.8,
      textAlign: "right",
    },
  },
  expirationExpired: {
    ...h6Regular,
    color: "#F50050",
    textAlign: "right",
    "@media (max-width:940px)": {
      ...h7Regular,
      color: "#F50050",
      textAlign: "right",
    },
  },
  defaultRow: {
    marginTop: 40,
    ...defaultCheckboxOverrides,
  },

  // Mobile
  swipeWrapper: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 16,
    marginBottom: 16,
  },
  swipeRemoveAction: {
    ...h6Medium,
    position: "absolute",
    top: 0,
    bottom: 0,
    width: 96,
    border: "none",
    background: "#F50050",
    color: "#fff",
    "&:disabled": {
      opacity: 0.5,
    },
  },
  mobileContainer: {
    position: "relative",
    zIndex: 1,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    borderRadius: 16,
    padding: 24,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    touchAction: "pan-y",
  },
  mobileHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
  },
  defaultRowMobile: {
    ...defaultCheckboxOverrides,
  },

  // Remove confirmation modal
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    padding: "32px 48px",
    background: "#fff",
    borderRadius: 16,
    width: 320,
    boxSizing: "border-box",
  },
  modalHeader: {
    display: "flex",
    height: 56,
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 30,
    paddingBottom: 20,
    "@media (max-width:940px)": {
      height: 32,
    },
  },
  modalTitle: {
    ...h4Medium,
  },
  modalCloseIcon: {
    padding: 16,
    ...pointer,
  },
  modalConfirmButton: {
    margin: "32px 0 24px 0",
    height: 56,
    background: "#F50050",
    color: "#FFF",
    ...h5Medium,
    border: "none",
    width: "100%",
    borderRadius: 16,
    ...pointer,
    "&:disabled": {
      opacity: 0.5,
      cursor: "default",
    },
  },
  modalNotNow: {
    ...h6Medium,
    color: "#80BB34",
    display: "flex",
    justifyContent: "center",
    ...pointer,
  },
}));
